var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "h-100 documents-list", attrs: { "no-gutters": "" } },
    [
      _c(
        "b-container",
        { staticClass: "h-100", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { attrs: { id: "documents-container", fluid: "" } },
            [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "w-100 h-100" },
                    [_c("documents-loader")],
                    1
                  )
                : _c(
                    "b-card",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "footer-bg-variant": "white",
                        "body-class": "py-0 document-container-body",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "d-flex flex-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-content-start align-items-center",
                                    staticStyle: { "flex-basis": "78%" },
                                  },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "section-separator-title",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("documents.documentsList")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("refresh-button", {
                                      attrs: { loading: _vm.refreshing },
                                      on: { refresh: _vm.refreshDocuments },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "footer",
                          fn: function () {
                            return [
                              _c("classification-select-container", {
                                attrs: {
                                  "application-id": _vm.applicationId,
                                  "client-username": _vm.clientUsername,
                                  "documents-page": "",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("documents-toolbar", {
                        staticClass: "documents-toolbar-position",
                        attrs: {
                          "application-id": _vm.applicationId,
                          "client-username": _vm.clientUsername,
                          "client-details": _vm.clientDetails,
                        },
                        on: {
                          refresh: _vm.refreshDocuments,
                          openTags: _vm.openTagsModal,
                          openDocuments: _vm.openDocumentsContainer,
                        },
                      }),
                      _vm._v(" "),
                      _c("document-classification-container", {
                        attrs: {
                          "application-id": _vm.applicationId,
                          "client-username": _vm.clientUsername,
                        },
                        on: { "open-tags": _vm.openTagsModal },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("manage-document-tags-modal", {
        ref: "tagsModal",
        attrs: { "label-name": _vm.labelName },
        on: { refreshDocuments: _vm.refreshDocuments },
      }),
      _vm._v(" "),
      _c("send-documents-to-lender-modal", {
        ref: "sendDocumentsToLenderModal",
        attrs: {
          "documents-to-send": _vm.documentsToSend,
          "lender-name": _vm.lenderName,
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          submission: _vm.submission,
          "document-list-empty": _vm.documentListEmpty,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }